import * as actionTypes from "actions/fulfillment/types";

const INITIAL_STATE = {
  address: null,
};

export default function (state = INITIAL_STATE, action) {
  const { WRO_SELECT_ADDRESS, WRO_CREATE_RESET } = actionTypes;

  switch (action.type) {
    case WRO_SELECT_ADDRESS:
      return { ...state, address: action.address };

    case WRO_CREATE_RESET:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
}
